import React from 'react';
import { Route, Switch } from 'react-router';
import Layout from 'components/Layout';
import List from './List';
import Form from './Form';

const Newspaper = () => (
  <Layout>
    <Switch>
      <Route exact path="/newspapers" component={List} />
      <Route exact path="/newspapers/new" component={Form} />
      <Route exact path="/newspapers/:id" component={Form} />
    </Switch>
  </Layout>
);

export default Newspaper;
